import React, {useEffect, useState} from "react";
import ModalCreateOrder from "../modals/create-order-delivery";
import { deliveriesService, orderDeliveryService, userServices } from "../../services";
import {Button, notification, Popconfirm, Upload} from "antd";
import ModalAttachDriverOrderDelivery from "../modals/attach-driver-order-delivery";
import moment from "moment";
import {
    DELIVERY_AWAITING_LOADING,
    DELIVERY_BOOKED,
    DELIVERY_ENROUTE,
    DELIVERY_ORDER_FILLED,
    DELIVERY_LOADING,
    DELIVERY_AGREED,
    DELIVERY_RESERVED,
    DELIVERY_FREE,
    DELIVERY_ORDER_APPROVED,
    DELIVERY_ORDER_AGREED,
    DELIVERY_ORDER_AWAITING_AGREED,
    DELIVERY_IN_TENDER
} from "../../helpers/delivery_status.helper";
import ModalListOrdersDelivery from "../modals/list-orders-delivery";
import ModalListOffersDelivery from "../modals/list-offers-delivery";
import {
    CREATE_DELIVERY, EN_ROUTE_DELIVERY,
    UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY,
    VIEW_AGREED_DELIVERIES_LOGIST, VIEW_BOOKED_DELIVERIES_LOGIST,
    FULL_ACCESS_TO_OTHER_CONSIGNORS_DELIVERIES
} from "../../helpers/user_permission.helper";
import ModalDriverInfo from "../modals/driver-info";
import ModalUploadDeliveryDocs from "../modals/attach-delivery-docs-consignor";
import ModalChangeDeliveryShipperCompany from "../modals/change-delivery-shipper-company";
import ModalAddDriversPhotosOnLoadingDelivery from "../modals/add-driver-photos-on-loading-delivery";
import ModalShowDriversPhotosByDistCenter from "../modals/show-drivers-photos-by-dist-center";
import ModalReturnLoadingDelivery from "../modals/return-loading-delivery";
import ModalShowOrderDocs from "../modals/order-docs";
import ModalReturnToEnRoute from "../modals/return-to-en-route";
import ModalSignUpForLoadingFriendly from "../modals/sign-up-for-loading-friendly";
import ModalChooseLoadingGate from "../modals/choose-time-loading";
import i18n from "../../i18n";

export function LogistShortButton({ delivery, permissions, setNeedUpdate, setStopListUpdate, setLoadingDelivItem, timerEnabled }) {
    const user = userServices.getUser();

    if (typeof (delivery.Permissions) == "undefined") {
        return null;
    }
    if (delivery.Permissions.IsAvailableManageDelivery === false) {
        return null;
    }

    const dateShipmentRus = moment(delivery.DateShipment).format("D MMMM YYYY");

    const [showModalOrdersDelivery, setShowModalOrdersDelivery] = useState(false);
    const [showModalOffersDelivery, setShowModalOffersDelivery] = useState(false);
    const [showModalCreateOrder, setShowModalCreateOrder] = useState(false);
    const [showModalAttachDriver, setShowModalAttachDriver] = useState(false);
    const [showModalDriverInfo, setShowDriverModalInfo] = useState(false);
    const [showModalAgreeDelivery, setShowAgreeDelivery] = useState(false);
    const [showModalChangeShipperCompany, setShowModalChangeShipperCompany] = useState(false);
    const [showModalUploadDriversPhotos, setShowModalUploadDriversPhotos] = useState(false);
    const [showModalDriversPhotos, setShowModalDriversPhotos] = useState(false);
    const [showModalSignUpLoadingFriendly, setShowModalSignUpLoadingFriendly] = useState(false);
    const [isModalReturnLoadingShow, setIsModalReturnLoadingShow] = useState(null);
    const [isModalReturnToEnRouteShow, setIsModalReturnToEnRouteShow] = useState(null);
    const [showModalSignUpForLoading, setShowModalSignUpForLoading] = useState(null);

    const [paymentType, setPaymentType] = useState(null);
    useEffect(() => {
        if (delivery.Prices) {
            const price = delivery.Prices.find(e => e.Price !== null);
            if (price) {
                setPaymentType(price.PaymentType.Id);
            }
        }
    }, [delivery]);

    const onClickAddToArchive = (e) => {
        e.preventDefault();
        setLoadingDelivItem(true);

        deliveriesService
            .archive(delivery.Id)
            .then((response) => {
                notification.success({
                    message: i18n.t('components.notification.titles.archive'),
                    description: response.message,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.archive'),
                    description: error,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            });
    };

    const onClickCancelLoadingAppointment = (e) => {
        e.preventDefault();

        deliveriesService
            .cancelLoadingSignUp(delivery.Id)
            .then((response) => {
                notification.success({
                    message: i18n.t('components.notification.titles.cancelLoadingSignUp'),
                    description: response.message
                });
                setNeedUpdate(true);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.cancelLoadingSignUp'),
                    description: error
                })
                setNeedUpdate(true);
            })
    }

    const onClickEnRouteDelivery = (e) => {
        e.preventDefault();
        setLoadingDelivItem(true);

        deliveriesService
            .enRoute(delivery.Id)
            .then((response) => {
                notification.success({
                    message: i18n.t('components.notification.titles.enRoute'),
                    description: response.message,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.enRoute'),
                    description: error,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            });
    };

    const onClickChangeToLoading = (e) => {
        e.preventDefault();
        setLoadingDelivItem(true);

        deliveriesService
            .changeToLoading(delivery.Id)
            .then((response) => {
                notification.success({
                    message: i18n.t('components.notification.titles.changeToLoading'),
                    description: response.message,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.changeToLoading'),
                    description: error,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            });
    };

    const onClickNoteActualLoadTime = (e) => {
        e.preventDefault();
        setLoadingDelivItem(true);

        deliveriesService
            .noteActualLoadTime(delivery.Id)
            .then((response) => {
                notification.success({
                    message: i18n.t('components.notification.titles.noteActualLoadTime'),
                    description: response.message,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.noteActualLoadTime'),
                    description: error,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            });
    };

    const onClickNoteDriverArrivedTime = (e) => {
        e.preventDefault();
        setLoadingDelivItem(true);

        deliveriesService
            .noteDriverArrivedTime(delivery.Id)
            .then((response) => {
                notification.success({
                    message: i18n.t('components.notification.titles.noteDriverArrivedTime'),
                    description: response.message,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.noteDriverArrivedTime'),
                    description: error,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            });
    };

    const onClickAgreeWithoutDocs = (e) => {
        e.preventDefault();
        setLoadingDelivItem(true);

        orderDeliveryService
            .agreeWithoutDocs(delivery.Order.Id, true)
            .then((response) => {
                notification.success({
                    message: i18n.t('components.notification.titles.agreeWithoutDocs'),
                    description: response.message,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.agreeWithoutDocs'),
                    description: error,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            });
    };

    const onClickShowOrders = (e) => {
        e.preventDefault();
        setStopListUpdate(true);
        setShowModalOrdersDelivery(true);
    };

    const onClickShowOffers = (e) => {
        e.preventDefault();
        setStopListUpdate(true);
        setShowModalOffersDelivery(true);
    };

    const onClickCreateOrderDelivery = (e) => {
        e.preventDefault();
        setStopListUpdate(true);
        setShowModalCreateOrder(true);
    };

    const onClickShowModalDriverInfo = (e) => {
        e.preventDefault();
        setShowDriverModalInfo(true);
    };

    const onClickShowAgreeDelivery = (e) => {
        e.preventDefault();
        setStopListUpdate(true);
        setShowAgreeDelivery(true);
    };

    const onClickShowModalSignUpLoadingFriendly = (e) => {
        e.preventDefault();
        setShowModalSignUpLoadingFriendly(true);
    }

    const onCLickShowUserDoc = (filePath) => {
        window.open(filePath);
    };

    const onClickDriversPhoto = (e) => {
        e.preventDefault();
        setShowModalUploadDriversPhotos(true);
    };

    const onClickShowDriversPhotos = (e) => {
        e.preventDefault();
        setShowModalDriversPhotos(true);
    };

    const handleGoToLink = link => {
        window.open(link, '_blank', 'noopener,noreferrer');
    }

    const onDetachDriver = (e) => {
        e.preventDefault();

        setLoadingDelivItem(true);

        orderDeliveryService
            .detachDriver(delivery.Order.Id)
            .then((response) => {
                notification.success({
                    message: i18n.t('components.notification.titles.detachDriver'),
                    description: response.message,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            })
            .catch((error) => {
                notification.error({
                    message: i18n.t('components.notification.titles.detachDriver'),
                    description: error,
                });

                setLoadingDelivItem(false);
                setNeedUpdate(true);
            });
    }

    let btnViewOrders = null;
    let btnViewOffers = null;
    let btnCreateOrder = null;
    let btnAgreeWithoutDocs = null;
    let btnEdoAgreement = null;
    let btnEdoProcuration = null;
    let btnFillOrder = null;
    let btnSetEnroute = null;
    let btnSetArchive = null;
    let btnShowDriverInfo = null;
    let btnShowUserDoc = null;
    let btnShowProcuration = null;
    let btnEnRouteDelivery = null;
    let btnUploadDriversPhotosOnLoading = null;
    let btnDetachDriver = null;
    let btnAgreeOrderDelivery = null;
    let btnChangeShipperCompany = null;
    let btnShowDriversPhotos = null;
    let btnNoteActualLoadTime = null;
    let btnReturnLoadingDelivery = null;
    let btnReturnToEnRoute = null;
    let btnNoteDriverArrivedTime = null;
    let btnSignUpForLoadingToFriendlyDistCenter = null;
    let btnCancelSignUpForLoadingToFriendlyDistCenter = null;
    let btnSignUpForLoading = null;
    let btnCancelSignForLoading = null;


    if (delivery.Status === DELIVERY_ENROUTE) {
        btnSetArchive = (
            <a className="action-button typical-btn-blue" onClick={onClickAddToArchive}>
              {i18n.t('components.tools.logistShortButton.buttons.addToArchive')}
            </a>
        );
    }
    if(delivery.Status === DELIVERY_ENROUTE) {
        btnReturnLoadingDelivery = (
          <React.Fragment key={`return-loading-button-${delivery.Id}`}>
              <button className="action-button"
                      onClick={() => {
                          setIsModalReturnLoadingShow(delivery.Id);
                      }}
              >{i18n.t('components.tools.logistShortButton.buttons.returnToLoading')}
              </button>
              <ModalReturnLoadingDelivery
                onCloseModal={() => {
                    setIsModalReturnLoadingShow(null);
                }}
                isShow={isModalReturnLoadingShow === delivery.Id}
                id={delivery.Id}/>
          </React.Fragment>
        );
    }
    if(delivery.Status === DELIVERY_LOADING) {
        btnReturnLoadingDelivery = (
          <React.Fragment key={`return-loading-button-${delivery.Id}`}>
              <button className="action-button"
                      onClick={() => {
                          setIsModalReturnLoadingShow(delivery.Id);
                      }}
              >{i18n.t('components.tools.logistShortButton.buttons.cancelLoading')}
              </button>
              <ModalReturnLoadingDelivery
                onCloseModal={() => {
                    setIsModalReturnLoadingShow(null);
                }}
                isShow={isModalReturnLoadingShow === delivery.Id}
                id={delivery.Id}/>
          </React.Fragment>
        );
    }
    const accessToSetOnLoading = (
        user.isAccessTo(VIEW_AGREED_DELIVERIES_LOGIST) ||
        user.isAccessTo(CREATE_DELIVERY) ||
        user.isAccessTo(UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY)
    ) && (delivery.Status === DELIVERY_AWAITING_LOADING || delivery.Status === DELIVERY_LOADING);

    if (accessToSetOnLoading) {
        if (delivery.Permissions.IsNeedAddParams) {
            if (user.isAccessTo(UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY)) {
                btnUploadDriversPhotosOnLoading = (
                    <React.Fragment>
                        <a className="action-button typical-btn-blue" onClick={onClickDriversPhoto}>
                          {i18n.t('components.tools.logistShortButton.buttons.uploadDriversPhotos')}
                        </a>
                        <ModalAddDriversPhotosOnLoadingDelivery
                            deliveryID={delivery.Id}
                            isShow={showModalUploadDriversPhotos}
                            setIsShow={setShowModalUploadDriversPhotos}
                            setNeedUpdate={setNeedUpdate}
                            setStopListUpdate={setStopListUpdate}
                        />
                    </React.Fragment>
                );
            }
        } else {
            if (
                (user.isAccessTo(EN_ROUTE_DELIVERY) || user.isAccessTo(UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY)) &&
                delivery.Status === DELIVERY_AWAITING_LOADING
            ) {
                btnSetEnroute = (
                    <Popconfirm
                      title={i18n.t('main.confirm.questions')}
                      okText={i18n.t('main.confirm.answer.yes')}
                      cancelText={i18n.t('main.confirm.answer.no')}
                        onConfirm={onClickChangeToLoading}
                    >
                        <a className="action-button typical-btn-blue">
                            <span className="speedometer">{i18n.t('components.tools.logistShortButton.buttons.loading')}</span>
                        </a>
                    </Popconfirm>
                );
            }
        }
    }
    if(delivery.Status == DELIVERY_AWAITING_LOADING && delivery.DriverArrivedTime === null && !delivery.IsMultimodal) {
        btnNoteDriverArrivedTime = (
            <Popconfirm
              title={i18n.t('main.confirm.questions')}
              okText={i18n.t('main.confirm.answer.yes')}
              cancelText={i18n.t('main.confirm.answer.no')}
                onConfirm={onClickNoteDriverArrivedTime}
            >
                <a className="action-button">
                  {i18n.t('components.tools.logistShortButton.buttons.driverArrived')}
                </a>
            </Popconfirm>
        );
    }

    if (delivery.Status === DELIVERY_LOADING && user.isAccessTo(EN_ROUTE_DELIVERY) && !delivery.IsMultimodal) {
        btnEnRouteDelivery = (
            <Popconfirm
              title={i18n.t('main.confirm.questions')}
              okText={i18n.t('main.confirm.answer.yes')}
              cancelText={i18n.t('main.confirm.answer.no')}
                onConfirm={onClickEnRouteDelivery}
            >
                <a className="action-button typical-btn-blue">
                  {i18n.t('components.tools.logistShortButton.buttons.enRoute')}
                </a>
            </Popconfirm>
        );
    }

    if (delivery.Order && delivery.Order.Status === DELIVERY_ORDER_FILLED) {
        if (delivery.Permissions.IsAvailableAgreeWithoutDocs) {
            btnAgreeWithoutDocs = (
                <a className="action-button typical-btn-blue" onClick={onClickAgreeWithoutDocs}>
                  {i18n.t('components.tools.logistShortButton.buttons.agreeWithoutDocs')}
                </a>
            );
        }
    }

    if(delivery.Order && delivery.Order.EdoDocs) {
        if(delivery.Order.EdoDocs.agreement && delivery.Order.EdoDocs.agreement.shipperLinks) {
            let agreement = delivery.Order.EdoDocs.agreement;
            btnEdoAgreement = 
                Object.keys(agreement.shipperLinks).map((key) => {
                    return (<>
                        <a className="action-button typical-btn-blue" onClick={() => handleGoToLink(agreement.shipperLinks[key])}>
                            {i18n.t('components.tools.logistShortButton.buttons.edoAgreement.' + agreement.status)}
                        </a>
                    </>)
                });
        }

        if(delivery.Order.EdoDocs.procuration && delivery.Order.EdoDocs.procuration.shipperLinks) {
            let procuration = delivery.Order.EdoDocs.procuration;
            btnEdoProcuration = 
                Object.keys(procuration.shipperLinks).map((key) => {
                    return (<>
                        <a className="action-button typical-btn-blue" onClick={() => handleGoToLink(procuration.shipperLinks[key])}>
                            {i18n.t('components.tools.logistShortButton.buttons.edoProcuration.' + procuration.status)}
                        </a>
                    </>)
                });
        }
    }

    if (delivery.Order && delivery.Order.Company.Driver) {
        btnShowDriverInfo = (
            <>
                <a className="action-button typical-btn-blue" onClick={onClickShowModalDriverInfo}>
                  {i18n.t('components.tools.logistShortButton.buttons.driverInfo')}
                </a>
                <ModalDriverInfo isShow={showModalDriverInfo}
                                 setIsShow={setShowDriverModalInfo}
                                 driverId={delivery.Order.Company.Driver.Id}
                                 truckId={delivery.Order.Company.Driver.Truck ? delivery.Order.Company.Driver.Truck.Id : null}
                                 trailId={delivery.Order.Company.Driver.Trail ? delivery.Order.Company.Driver.Trail.Id : null}
                />
            </>
        );
    }

    if (delivery.Permissions.IsAvailableChangeShipperCompany) {
        console.log(delivery);
        btnChangeShipperCompany = (
            <>
                <a className="action-button typical-btn-red" onClick={() => {
                    setShowModalChangeShipperCompany(true);
                }}>
                  {i18n.t('components.tools.logistShortButton.buttons.changeShipperCompany')}
                </a>
                <ModalChangeDeliveryShipperCompany
                    isShow={showModalChangeShipperCompany}
                    setIsShow={setShowModalChangeShipperCompany}
                    setIsNeedUpdate={setNeedUpdate}
                    setStopListUpdate={setStopListUpdate}
                    currentShipperCompany={delivery.CustomerCompanyId}
                    currentDistCenter={delivery.DistributionCenter.Id}
                    deliveryID={delivery.Id}
                    deliveryConsignorId={delivery.CustomerConsignorId}
                />
            </>
        );
    }

    if ((delivery.Status === DELIVERY_FREE || delivery.Status === DELIVERY_RESERVED)) {
        const countOrders = (typeof (delivery.CountOrders) !== "undefined") ? delivery.CountOrders : 0;// delivery.Orders !== null ? delivery.Orders.length : 0;
        if (countOrders && delivery.Permissions.IsAvailableViewListOrders) {
            btnViewOrders = (
                <div>
                    <a className="action-button typical-btn-red" onClick={onClickShowOrders}>
                      {i18n.t('components.tools.logistShortButton.buttons.orders')} ({countOrders})
                    </a>
                    <ModalListOrdersDelivery
                        isShow={showModalOrdersDelivery}
                        setIsShow={setShowModalOrdersDelivery}
                        deliveryId={delivery.Id}
                        setNeedUpdateDeliveryList={setNeedUpdate}
                        setStopListUpdate={setStopListUpdate}
                        delivery={delivery}
                    />
                </div>
            );
        }
    }

    if ((delivery.Status === DELIVERY_IN_TENDER)) {
        const countOffers = (typeof (delivery.CountOffers) !== "undefined") ? delivery.CountOffers : 0;// delivery.Orders !== null ? delivery.Orders.length : 0;
        if (countOffers && delivery.Permissions.IsAvailableViewListOrders) {
            btnViewOffers = (
                <div>
                    <a className="action-button typical-btn-blue" onClick={onClickShowOffers}>
                      {i18n.t('components.tools.logistShortButton.buttons.offers')} ({countOffers})
                    </a>
                    <ModalListOffersDelivery
                        isShow={showModalOffersDelivery}
                        setIsShow={setShowModalOffersDelivery}
                        deliveryId={delivery.Id}
                        setNeedUpdateDeliveryList={setNeedUpdate}
                        setStopListUpdate={setStopListUpdate}
                        delivery={delivery}
                    />
                </div>
            );
        }
    }

    if (delivery.Status === DELIVERY_AGREED) {
        btnReturnToEnRoute = (
          <React.Fragment key={`invoice-button-${delivery.Id}`}>
              <button className="action-button"
                      onClick={() => {
                          setIsModalReturnToEnRouteShow(delivery.Id);
                      }}
              >{i18n.t('components.tools.logistShortButton.buttons.returnToEnRoute')}
              </button>
              <ModalReturnToEnRoute
                onCloseModal={() => {
                    setIsModalReturnToEnRouteShow(null);
                }}
                isShow={isModalReturnToEnRouteShow === delivery.Id}
                id={delivery.Id}/>
          </React.Fragment>
        );
    }

    //Заполнить заявку
    if (delivery.Permissions.IsAccessCreatedOrder && delivery.Order.Status !== DELIVERY_ORDER_FILLED && delivery.Order.Status !== DELIVERY_ORDER_AWAITING_AGREED) {
        const nameRegionLastPointUnload = delivery.PlacesUnload.length
            ? delivery.PlacesUnload[delivery.PlacesUnload.length - 1].City
            : "-";

        const regionLoad = delivery.PlaceLoad.City ? delivery.PlaceLoad.City : "-";
        const isForeignDelivery = delivery.IsForeignDelivery;

        btnFillOrder = (
            <>
                <a
                    className="action-button typical-btn-green"
                    onClick={(e) => {
                        e.preventDefault();
                        setStopListUpdate(true);
                        setShowModalAttachDriver(true);
                    }}
                >
                  {i18n.t('components.tools.logistShortButton.buttons.startFillOrder')}
                </a>
                <ModalAttachDriverOrderDelivery
                    key={`modal_${delivery.Id}`}
                    isShow={showModalAttachDriver}
                    setIsShow={setShowModalAttachDriver}
                    setNeedUpdateDeliveryList={setNeedUpdate}
                    orderId={delivery.Order.Id}
                    setStopListUpdate={setStopListUpdate}
                    companyId={delivery.Order.Company.Id}
                    deliveryDateShipmentRus={dateShipmentRus}
                    deliveryPrice={delivery.Order.Price}
                    deliveryRegionLoad={regionLoad}
                    deliveryRegionUnload={nameRegionLastPointUnload}
                    isForeignDelivery={isForeignDelivery}
                    deliveryContractType={delivery.ContractType}
                    permissions={delivery.Permissions}
                    delivery={delivery}
                />
            </>
        );
    }

    if (delivery.Permissions.IsAvailableCreate && !timerEnabled && (delivery.Status === DELIVERY_FREE || delivery.Status === DELIVERY_RESERVED || delivery.Status === DELIVERY_BOOKED)) {
        btnCreateOrder = (
            <React.Fragment>
                <a className="action-button" onClick={onClickCreateOrderDelivery}>
                    <span className="speedometer">{i18n.t('components.tools.logistShortButton.buttons.createOrder')}</span>
                </a>
                <ModalCreateOrder
                    isShow={showModalCreateOrder}
                    setIsShow={setShowModalCreateOrder}
                    delivery={delivery}
                    setNeedUpdateDeliveryList={setNeedUpdate}
                    setStopListUpdate={setStopListUpdate}
                    paymentType={paymentType}
                    setPaymentType={setPaymentType}
                />
            </React.Fragment>
        );
    }

    if (user.isAccessTo(VIEW_BOOKED_DELIVERIES_LOGIST) && delivery.Order && delivery.Order.Doc && delivery.Order.Status !== DELIVERY_ORDER_AWAITING_AGREED) {
        btnShowUserDoc = (
            <React.Fragment>
                <a className="action-button typical-btn-blue" onClick={() => onCLickShowUserDoc(delivery.Order.Doc)}>
                  {i18n.t('components.tools.logistShortButton.buttons.showUserDoc')}
                </a>
            </React.Fragment>
        );
    }

    if (user.isAccessTo(VIEW_BOOKED_DELIVERIES_LOGIST) && delivery.Order && delivery.Order.Procuration && delivery.Order.Status !== DELIVERY_ORDER_AWAITING_AGREED) {
        btnShowProcuration = (
            <React.Fragment>
                <a className="action-button typical-btn-blue" onClick={() => onCLickShowUserDoc(delivery.Order.Procuration)}>
                  {i18n.t('components.tools.logistShortButton.buttons.showUserDoc2')}
                </a>
            </React.Fragment>
        );
    }

    if (delivery.Order && delivery.Order.Status === DELIVERY_ORDER_AWAITING_AGREED) {
        btnAgreeOrderDelivery = (
            <>
                <a className="action-button typical-btn-green" onClick={onClickShowAgreeDelivery}>
                  {i18n.t('components.tools.logistShortButton.buttons.approve')}
                </a>
                <ModalUploadDeliveryDocs
                    isShow={showModalAgreeDelivery}
                    setIsShow={setShowAgreeDelivery}
                    orderDelivery={delivery.Order}
                    setStopListUpdate={setStopListUpdate}
                    setNeedUpdateDeliveries={setNeedUpdate}
                />
            </>
        );
    }

    if (delivery && !delivery.IsMultimodal && user.isAccessTo(EN_ROUTE_DELIVERY) && (delivery.Status === DELIVERY_BOOKED || delivery.Status === DELIVERY_AWAITING_LOADING)) {
        if (delivery.Order && (delivery.Order.Status === DELIVERY_ORDER_FILLED || delivery.Order.Status === DELIVERY_ORDER_AGREED)) {
            btnDetachDriver = (
                <Popconfirm
                  title={i18n.t('main.confirm.questions')}
                  okText={i18n.t('main.confirm.answer.yes')}
                  cancelText={i18n.t('main.confirm.answer.no')}
                    onConfirm={onDetachDriver}
                >
                    <a className="action-button typical-btn-red">
                      {i18n.t('components.tools.logistShortButton.buttons.detachDriver')}
                    </a>
                </Popconfirm>
            );
        }
    }

    // Только для мегасупердоступа и не дружественных
    if (user.isAccessTo(FULL_ACCESS_TO_OTHER_CONSIGNORS_DELIVERIES) && delivery.Permissions.IsCanSignUpForLoading
        && delivery.LoadingSign == null
        && !delivery.Permissions.IsCanSignUpForLoadingFriendly
        && !delivery.IsMultimodal
    ) {
        btnSignUpForLoading = <>
            <button
              className={`action-button`}
              onClick={() => {
                setShowModalSignUpForLoading(delivery.Id);
              }}
            >
              {i18n.t('components.tools.logistShortButton.buttons.signUpForLoading')}
            </button>
            <ModalChooseLoadingGate id={delivery.Id}
                                    isShow={showModalSignUpForLoading === delivery.Id}
                                    onCloseModal={() => {
                                      setShowModalSignUpForLoading(null)
                                    }}
                                    setNeedUpdate={setNeedUpdate}
                                    date={delivery.Order.Date}
            />
          </>
    }

    if (user.isAccessTo(FULL_ACCESS_TO_OTHER_CONSIGNORS_DELIVERIES)
        && delivery.Permissions.IsCanSignUpForLoading
        && delivery.LoadingSign != null
        && !delivery.Permissions.IsCanSignUpForLoadingFriendly
    ) {
        btnCancelSignForLoading = (
            <Popconfirm
              title={i18n.t('main.confirm.questions')}
              okText={i18n.t('main.confirm.answer.yes')}
              cancelText={i18n.t('main.confirm.answer.no')}
                onConfirm={onClickCancelLoadingAppointment}
            >
                <a className="action-button typical-btn-red">
                  {i18n.t('components.tools.logistShortButton.buttons.cancelLoadingAppointment')}
                </a>
            </Popconfirm>
        )
    }

    if (delivery.Permissions.IsCanSignUpForLoadingFriendly && delivery.LoadingSign == null) {
        btnSignUpForLoadingToFriendlyDistCenter = (
            <React.Fragment>
                <a className="action-button typical-btn-green" onClick={onClickShowModalSignUpLoadingFriendly}>
                  {i18n.t('components.tools.logistShortButton.buttons.signUpLoadingFriendly')}
                </a>
                <ModalSignUpForLoadingFriendly
                    isShow={showModalSignUpLoadingFriendly}
                    setIsShow={setShowModalSignUpLoadingFriendly}
                    orderDate={delivery.Order.Date}
                    deliveryId={delivery.Id}
                    setNeedUpdate={setNeedUpdate}
                />
            </React.Fragment>
        );
    }

    if (delivery.Permissions.IsCanSignUpForLoadingFriendly && delivery.LoadingSign != null) {
        btnCancelSignUpForLoadingToFriendlyDistCenter = (
            <Popconfirm
              title={i18n.t('main.confirm.questions')}
              okText={i18n.t('main.confirm.answer.yes')}
              cancelText={i18n.t('main.confirm.answer.no')}
                onConfirm={onClickCancelLoadingAppointment}
            >
                <a className="action-button typical-btn-red">
                  {i18n.t('components.tools.logistShortButton.buttons.cancelLoadingAppointment')}
                </a>
            </Popconfirm>
        )
    }

    if (delivery.Permissions.IsAddParamsUploaded) {
        btnShowDriversPhotos = (
            <React.Fragment>
                <a className="action-button typical-btn-blue" onClick={onClickShowDriversPhotos}>
                  {i18n.t('components.tools.logistShortButton.buttons.driversPhotos')}
                </a>

                <ModalShowDriversPhotosByDistCenter
                    isShow={showModalDriversPhotos}
                    setIsShow={setShowModalDriversPhotos}
                    deliveryID={delivery.Id}
                    setStopListUpdate={setStopListUpdate}
                    setNeedUpdate={setNeedUpdate}
                />
            </React.Fragment>
        );
    }

    return (
        <div>
            {btnAgreeOrderDelivery}
            {btnViewOrders}
            {btnViewOffers}
            {btnCreateOrder}
            {btnChangeShipperCompany}
            {btnFillOrder}
            {btnUploadDriversPhotosOnLoading}
            {btnEnRouteDelivery}
            {btnSetEnroute}
            {btnAgreeWithoutDocs}
            {btnEdoAgreement}
            {btnSetArchive}
            {btnShowDriverInfo}
            {btnShowUserDoc}
            {btnShowProcuration}
            {btnEdoProcuration}
            {btnShowDriversPhotos}
            {btnNoteActualLoadTime}
            {btnNoteDriverArrivedTime}
            {btnDetachDriver}
            {btnReturnLoadingDelivery}
            {btnReturnToEnRoute}
            {btnSignUpForLoadingToFriendlyDistCenter}
            {btnCancelSignUpForLoadingToFriendlyDistCenter}
            {btnCancelSignForLoading}
            {btnSignUpForLoading}
        </div>
    );
}
